import React from 'react';
import LeadershipChrome from '@/components/LeadershipChrome';

/** Wrap an admin page in the shared FIC chrome (page owns its light title). */
export default function LeadershipScreen({ children, actions }) {
  return (
    <LeadershipChrome actions={actions} homeHref="/management" roleLabel="Leadership" showLeadershipMenu>
      {children}
    </LeadershipChrome>
  );
}
